import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import InfoBorderBlue from '../UI/InfoBorderBlue/InfoBorderBlue'


const Expertise = (props) => {

    let content = props.i18n.getResource(props.i18n.language, 'homepage')['section4']['list'];
    let contentKeys = Object.keys(content)

    let display = contentKeys.map((key) => {
        return content[key]['text'] ? (
            <Col md={6}>
                <InfoBorderBlue
                    key={key}
                    title={content[key]['title']}
                    text={content[key]['text']}
                />
            </Col>
        ) :
            (
                <Col md={6}>
                    <InfoBorderBlue
                        key={key}
                        title={content[key]['title']}
                    />
                </Col >
            )
    })

    return (
        <Container className="expertise-mobile">
            <div className="d-flex d-md-none">
                <InfoBorderBlue>
                    {content}
                </InfoBorderBlue>
            </div>
            <Row className="d-none d-md-flex content">
                <Col className="padding-0-lr py-5 d-flex flex-column justify-content-center">
                    <div className='expertise-content'>{display}</div>
                </Col>
            </Row>
        </Container>
    )
}

export default Expertise